<template><div><h1 id="benutzerfunktionen" tabindex="-1"><a class="header-anchor" href="#benutzerfunktionen"><span>Benutzerfunktionen</span></a></h1>
<p>Benutzerfunktionen — Definiert die Benutzerfunktionen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In diesem Frame werden die Benutzerfunktionen definiert. Eine Benutzerfunktion beinhaltet eine oder mehrere <RouteLink to="/referenz/refs/ft.refdata.techfunktionen.html" title="Technische Funktionen">Technische Funktionen</RouteLink>.</p>
<div class="hint-container tip">
<p class="hint-container-title">Anmerkung</p>
<p>Die spezielle Benutzerfunktion &quot;Admin&quot; beinhaltet mehrere technische Funktionen die unter anderem die Zugriffe auf die Verwaltung von Stammtabellen erlaubt. Diese Benutzerfunktion ist aus sicherheitsgründen Arenae vorbehalten.</p>
</div>
<p>Pfad: <code v-pre>Systemverwaltung → Benutzerverwaltung → Benutzerfunktionen</code></p>
<h2 id="datenfelder-benutzerfunktionen" tabindex="-1"><a class="header-anchor" href="#datenfelder-benutzerfunktionen"><span>Datenfelder (Benutzerfunktionen)</span></a></h2>
<dl>
<dt>Funktion</dt>
<dd>Bezeichnung der Funktion</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung der Funktion</dd>
</dl>
<h2 id="datenfelder-zugeordnete-benutzer" tabindex="-1"><a class="header-anchor" href="#datenfelder-zugeordnete-benutzer"><span>Datenfelder (Zugeordnete Benutzer)</span></a></h2>
<p>Zeigt die zugeordneten Benutzer zu der Benutzerfunktion an.</p>
<dl>
<dt>Benutzer</dt>
<dd>Kürzel des Benutzers</dd>
<dt>Benutzername</dt>
<dd>Name des Benutzers</dd>
</dl>
<h2 id="datenfelder-zugeordnete-benutzergruppen" tabindex="-1"><a class="header-anchor" href="#datenfelder-zugeordnete-benutzergruppen"><span>Datenfelder (Zugeordnete Benutzergruppen)</span></a></h2>
<p>Zeigt die zugeordneten Benutzergruppen zu der Benutzerfunktion an.</p>
<dl>
<dt>Gruppe</dt>
<dd>Bezeichnung der Gruppe</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung der Gruppe</dd>
</dl>
<h2 id="datenfelder-zugeordnete-technische-funktionen" tabindex="-1"><a class="header-anchor" href="#datenfelder-zugeordnete-technische-funktionen"><span>Datenfelder (Zugeordnete technische Funktionen)</span></a></h2>
<p>Zeigt die zugeordneten technischen Funktionen zu der Benutzerfunktion an.</p>
<dl>
<dt>Programm</dt>
<dd>Bezeichnung des Programms</dd>
<dt>Variablen</dt>
<dd>Variablen des Programms</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung des Programms</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/administration/benutzerverwaltung.html#Benutzerverwaltung" title="1. Benutzerverwaltung">Benutzerverwaltung</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.benutzergruppen.html" title="Benutzergruppen">Benutzergrupppen</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.techfunktionen.html" title="Technische Funktionen">Technische Funktionen</RouteLink></p>
</div></template>


